export const ORG_ADMIN = 'ORG_ADMIN';
export const SITE_OPERATIONS_MANAGER = 'SITE_OPERATIONS_MANAGER';
export const FIELD_OPERATOR = 'FIELD_OPERATOR';

export const ORG_FLEET_ROLES = [ORG_ADMIN, SITE_OPERATIONS_MANAGER, FIELD_OPERATOR];

export const ROLE_LABELS = {
  [ORG_ADMIN]: 'Organization Admin',
  [SITE_OPERATIONS_MANAGER]: 'Site Operations Manager',
  [FIELD_OPERATOR]: 'Field Operator',
};

export function getRoleLabel(role) {
  return ROLE_LABELS[role] || role?.replace?.(/_/g, ' ') || role;
}

export function getInvitationSignupSubtitle(invitation) {
  if (!invitation?.role) return '';
  const org = invitation.organizationName ? ` at ${invitation.organizationName}` : '';
  switch (invitation.role) {
    case ORG_ADMIN:
      return `Create your organization account${org} as Organization Admin.`;
    case SITE_OPERATIONS_MANAGER:
      return `Join${org} as Site Operations Manager to manage sites and field operators.`;
    case FIELD_OPERATOR:
      return `Join${org} as Field Operator for your assigned site(s).`;
    default:
      return `You've been invited to join${org} as ${getRoleLabel(invitation.role)}.`;
  }
}

export function canInviteFieldOperators(role) {
  return role === ORG_ADMIN || role === SITE_OPERATIONS_MANAGER || role === 'SUPER_ADMIN';
}

export function canManageInvitations(role) {
  return role === 'SUPER_ADMIN' || role === 'ADMIN' || role === ORG_ADMIN || role === SITE_OPERATIONS_MANAGER;
}
